import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, Card } from '@material-ui/core';
import { Modal } from 'antd';
import MainContainer from '../../../components/MainContainer';
import PaymentLogListPage from './PaymentLogList';
import PaymentLogModalPage from './PaymentLogModal';
import './PaymentLog.css';

@inject(
    'PaymentLogStore'
)
@observer
class PaymentLogPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
    }

    // ON CANCEL

    paymentLogModalOnCancel = () => {
        this.props.PaymentLogStore.setShowPaymentLogModal(false);
    }

    render() {
        const {
            showPaymentLogModal,
            paymentLogTitle,
        } = this.props.PaymentLogStore;

        return (
            <MainContainer title='Transactions History' menukey='payment-history'>
                <Modal
                    title={paymentLogTitle}
                    visible={showPaymentLogModal}
                    width={800}
                    footer={null}
                    onCancel={this.paymentLogModalOnCancel}
                    zIndex={1000}
                >
                    <PaymentLogModalPage />
                </Modal>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card style={{ height: 980, padding: 20, overflow: 'auto' }}>
                            <PaymentLogListPage />
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default PaymentLogPage;